import React from 'react'
import { Button, Skeleton, Typography } from '..'
import { SingleUser } from './UserSearch'
import { SingleClient } from './ClientSearch'
import { CheckUserRole } from '../CheckUserRole'
import { GET_RECENT_SEARCHES } from '../../../grapghQl/queries/dashboard'
import { useQuery } from '@apollo/client'
import { CloseRoundedIcon } from '../../../theme/icons'

export const RecentSearches = ({ closeFilterMenu = () => null }) => {
    const { isAssociate } = CheckUserRole();
    const { data: { recentSearchLog: { clients = [], users = [] } = {} } = {}, loading: fetchLoader } = useQuery(GET_RECENT_SEARCHES, {
        fetchPolicy: "cache-and-network"
    })

    const userList = (users?.length && users?.map(user => ({ ...user, name: `${user?.first_name} ${user?.last_name}` }))) || []

    return (<div className='p-3 flex flex-col gap-3 relative' >
        <Button text="" variant="tertiary" className="p-0 m-0 absolute right-3 ml-0 mr-auto" onClick={() => closeFilterMenu()} icon={<CloseRoundedIcon />} />
        <Typography variant="base" className="text-secondary-400 font-medium" text={`Recents`} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-h-[60vh] overflow-y-auto">
            {isAssociate ? <>
                {fetchLoader ?
                    Array.from({ length: 4 }, (_, i) => i + 1)?.map(loader => <ClientsLoader key={loader} />) :
                    !!clients?.length && clients?.map((client, index) =>
                        <SingleClient closeFilterMenu={closeFilterMenu} index={index} {...client} key={client?._id} />)}
            </ > : <div className='flex flex-col gap-2'>
                {fetchLoader ?
                    Array.from({ length: 4 }, (_, i) => i + 1)?.map(loader => <ClientsLoader key={loader} />) :
                    !!clients?.length && clients?.map((client, index) =>
                        <SingleClient closeFilterMenu={closeFilterMenu} index={index + 1} {...client} key={client?._id} />)}
            </div>}
            {!isAssociate && <div className='flex flex-col gap-2'>
                {fetchLoader ? [1, 2, 3, 4].map((item) => <UsersLoader key={item} />) :
                    !!userList?.length && userList?.map((team, index) => <SingleUser key={team?._id} closeFilterMenu={closeFilterMenu} index={index} {...team} />)}
            </div>}
        </div>

        {!fetchLoader && (!userList?.length && !clients?.length) && <div className='flex justify-center h-[8vh] items-center w-full'>
            <Typography variant="sm" text="No recent searches" className="text-secondary-400" />
        </div>}
    </div>)
}

const ClientsLoader = () => (
    <div className='flex gap-3 items-center w-full my-1'>
        <Skeleton parentClassName="w-fit" length={1} className="h-[2.7rem] w-[2.7rem] rounded-full" />
        <div className='w-full flex flex-col gap-2'>
            <Skeleton length={1} className="h-5 w-full rounded-md" />
            <Skeleton length={1} className="h-3 w-full rounded-md" />
        </div>
        <Skeleton parentClassName="w-fit" length={1} className="h-8 w-6 rounded-md" />
    </div>
)

const UsersLoader = () => (
    <div className='flex gap-3 items-center w-full my-1'>
        <Skeleton parentClassName="w-fit" length={1} className="h-[2.7rem] w-[2.7rem] rounded-full" />
        <div className='w-full flex flex-col gap-2'>
            <Skeleton length={1} className="h-5 w-full rounded-md" />
            <Skeleton length={1} className="h-3 w-full rounded-md" />
        </div>
    </div>
)